import api from './api';
import {
  DocumentSettings,
  UpdateDocumentSettingsDto,
  DocumentSettingsFlag,
} from '@/types/document-settings';

class DocumentSettingsService {
  /**
   * Get document settings for the acting member
   */
  async getSettings(
    memberId: string,
    documentId: string
  ): Promise<DocumentSettings | null> {
    try {
      const response = await api.get(
        `/members/${memberId}/documents/${documentId}/settings`
      );
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  /**
   * Get settings for multiple documents
   */
  async getBulkSettings(
    memberId: string,
    documentIds: string[]
  ): Promise<DocumentSettings[]> {
    const response = await api.post(
      `/members/${memberId}/document-settings/bulk`,
      { documentIds }
    );
    return response.data;
  }

  /**
   * Update document settings
   */
  async updateSettings(
    memberId: string,
    documentId: string,
    settings: UpdateDocumentSettingsDto
  ): Promise<DocumentSettings> {
    const response = await api.put(
      `/members/${memberId}/documents/${documentId}/settings`,
      settings
    );
    return response.data;
  }

  /**
   * Update a specific flag
   */
  async updateFlag(
    memberId: string,
    documentId: string,
    flag: DocumentSettingsFlag,
    value: boolean
  ): Promise<DocumentSettings> {
    const response = await api.put(
      `/members/${memberId}/documents/${documentId}/settings/flag/${flag}`,
      { value }
    );
    return response.data;
  }

  /**
   * Delete document settings
   */
  async deleteSettings(
    memberId: string,
    documentId: string
  ): Promise<void> {
    await api.delete(
      `/members/${memberId}/documents/${documentId}/settings`
    );
  }
}

export default new DocumentSettingsService();
